import { render, staticRenderFns } from "./inquiryDetail.vue?vue&type=template&id=5f00d5c4&scoped=true"
import script from "./inquiryDetail.vue?vue&type=script&lang=js"
export * from "./inquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./inquiryDetail.vue?vue&type=style&index=0&id=5f00d5c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f00d5c4",
  null
  
)

export default component.exports